
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vctrackervalue.factory:TrackervalueHelper
   *
   * @description
   *
   */
  angular
    .module('vctracker')
    .factory('TrackervalueHelper', TrackervalueHelper);
  
  
  TrackervalueHelper.$inject = ['Trackervalue', '$uibModal', '$log', 'Rlog'];
  
  function TrackervalueHelper(Trackervalue, $uibModal, $log, Rlog) {
    let TrackervalueHelperBase = {};
    
    TrackervalueHelperBase.editTrackervalue = editTrackervalue;
    TrackervalueHelperBase.addTrackervalue = addTrackervalue;
    
    
    function addTrackervalue(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackervalueform trackervalue="vm.trackervalue" parentsave="vm.childsave(trackervalue)" oncancel="vm.cancel()"></trackervaluenew></div>',
        controllerAs: 'trackervalueaCtrl',
        controller: ['trackervalue', function () {
          let vm = this;
          vm.trackervalue = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(trackervalue) {
            Trackervalue.$create(trackervalue).$then(function (newtrackervalue) {
              vm.created = true;
              success(newtrackervalue);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ trackervalue-helper.addTrackervalue: ', err);
              Rlog.error('vctracker', 'trackervalue-helper.addTrackervalue', 'Creation of new TRackervalue failed: ', {trackervalue: trackervalue});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          trackervalue: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editTrackervalue(ltrackervalue) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackervalueform trackervalue="trackervalueeCtrl.trackervalue" parentsave="trackervalueeCtrl.childsave(trackervalue)" oncancel="trackervalueeCtrl.cancel()"></trackervalueform></div>',
        controllerAs: 'trackervalueeCtrl',
        controller: ['trackervalue', function (strackervalue) {
          let vm = this;
          vm.trackervalue = strackervalue;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(trackervalue) {
            // vm.trackervalue = angular.copy(trackervalue);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in trackervalue) {
              if (trackervalue.hasOwnProperty(key)) {
                vm.trackervalue[key] = trackervalue[key];
              }
            }
            
            if (vm.trackervalue.$hasPendingActions()) {
              vm.trackervalue.$cancel();
              vm.trackervalue.$save();
              cancel();
            }
            else {
              vm.trackervalue.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          trackervalue: function () {
            return ltrackervalue;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return TrackervalueHelperBase;
  }
}());
